import request from '@/utils/request';

/**
 * 菜单
 * @param pram
 */
export function menuListApi() {
  return request({
    url: '/admin/merchant/getMenus',
    method: 'GET'
  });
}